import axios from 'axios';
import { filterProvidersUsingUA } from './filterProvidersUsingUA';
import { logAxiosError } from './log';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const ENABLE_AB_TESTING = process.env.REACT_APP_ENABLE_AB_TESTING === 'true';
const TOKEN_MAX_LENGTH = Number(process.env.REACT_APP_TOKEN_MAX_LENGTH);

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const getIframe = () => (inIframe() ? window.parent : null);

let campaignState;

export const types = {
  LOGIN_SUCCESS: 'LoginSuccess',
  LOGOUT_SUCCESS: 'LogoutSuccess',
  LOGOUT_FAILURE: 'LogoutFailure',
  NO_SESSION: 'NoSession',
  ERROR: 'Error',
};

const postMessageHelper = {
  checkForSpawner() {
    return !(typeof window === 'undefined' || !(getIframe() || window.opener));
  },
  send({ type, payload }) {
    if (typeof window === 'undefined') return false;
    const spawner = getIframe() || window.opener;
    const message = campaignState
      ? [
          {
            uim: {
              type,
              payload,
            },
          },
          campaignState.url,
        ]
      : [
          {
            uim: {
              type: types.ERROR,
              payload: 'Need a valid token to pass information',
            },
          },
          '*',
        ];
    if (spawner) {
      spawner.postMessage(...message);
    }
  },
  initToken(token) {
    const tokenRegex = new RegExp(`^[a-z0-9]{1,${TOKEN_MAX_LENGTH}}$`, 'i');
    const goodToken = tokenRegex.test(token);
    if (goodToken) {
      return axios
        .get(`${API_BASE_URL}/api/v1/application/${token}`, {
          withCredentials: ENABLE_AB_TESTING,
          headers: {
            ...(ENABLE_AB_TESTING && { ABTesting: true }),
          },
        })
        .then((campaign) => {
          campaignState = campaign.data;
          if (campaignState && campaignState.loginProviders) {
            campaignState.loginProviders = filterProvidersUsingUA(
              campaignState.loginProviders
            );
          }
          return campaign.data;
        })
        .catch((err) => {
          logAxiosError(err);
        });
    }

    return Promise.resolve();
  },
  redirect(path) {
    window.location.href = `${campaignState.url}${path}`;
  },
  types,
};

export { postMessageHelper };
